import React from 'react';

import QuoteService from '../../services/quoteService';
import { getTranslations } from '../../services/languageUtils';

import CAD from '../../assets/imgs/CAD.png';
import EUR from '../../assets/imgs/EUR.png';
import JPY from '../../assets/imgs/JPY.png';
import USD from '../../assets/imgs/USD.png';

const coins = [
    /*
      Sem `mock`. Cada moeda trazia um valor de exemplo escrito aqui, usado quando a
      cotação falhava — e exibido do mesmo jeito que uma cotação real, sem nada que o
      distinguisse. Preço inventado é pior que preço nenhum.
    */
    {value:'USD', label: 'USD Dollar', image: USD},
    {value:'EUR', label: 'EUR Euro', image: EUR},
    {value:'CAD', label: 'Canadian dollar', image: CAD},
    {value:'JPY', label: 'Japanese yen', image: JPY},
];

var dayOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

class CoinQuote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataStock: [],
      dispQuotes: true,
      translations: {}
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  componentDidMount() {
    this.refresh();
    this.loadTranslations();
  }

  refresh() {
    let that = this;
    // let day = Number(new Date().getDate());
    // let month = Number(new Date().getMonth())+1;

    // for(let k=0; k<stockMarket.length; k++){
      // QuoteService.getStockMarket().then(function(res){
      //   let temp = that.state.dataStock;
        // console.log(Object.keys(res.data['Time Series (Daily)']));
      //   for(let k=0; k<4; k++){
      //     temp.push({
      //       label: res.data.data.trends[k].symbol,
      //       open: res.data.data.trends[k].price,
      //       close: res.data.data.trends[k].previous_close
      //     });
      //   }
      //   that.setState({dataStock: temp});
      // });
    // }

    /*
      ── Por que as quatro cotações não apareciam ──

      A condição era `sessionStorage.getItem('USD') === ""`. Numa sessão nova o item não
      existe e `getItem` devolve `null`, que nunca é igual a `""` — então a busca NUNCA
      acontecia. Caía-se direto no ramo do cache, e o cache estava vazio: `Number(null)`
      é 0, e a tela mostrava "0,00" nas quatro moedas.

      A condição certa é "não tenho valor guardado", e é `!valor` que diz isso — vale para
      `null`, para `""` e para o item apagado.
    */
    const emCache = coins.every((moeda) => sessionStorage.getItem(moeda.value));

    if (emCache) {
      that.setState({
        data: coins.map((moeda) => ({
          coin: moeda.label,
          value: String(sessionStorage.getItem(moeda.value)).replace('.', ','),
          image: moeda.image,
        })),
      });
      return;
    }

    /*
      Uma promessa por moeda, resolvidas juntas, e o estado escrito UMA vez.

      Antes cada resposta fazia `push` no array do estado e chamava `setState` — o array
      era o mesmo objeto, mutado fora do React, e a ordem das quatro linhas dependia de
      qual requisição voltasse primeiro. Montar a lista inteira e escrever no fim tira as
      duas coisas do caminho.
    */
    Promise.all(
      coins.map((moeda) =>
        QuoteService.getQuoteDays(moeda.value + '-BRL', 1)
          .then((res) => {
            const cotacao = Number(res?.data?.[0]?.ask);
            if (!Number.isFinite(cotacao) || cotacao <= 0) throw new Error('sem cotação');
            return { moeda, valor: cotacao.toFixed(2) };
          })
          .catch((err) => {
            /*
              Havia aqui um valor de EXEMPLO, escrito no código (`mock: '5.23'`), exibido
              como se fosse cotação real. Preço inventado é pior que preço nenhum: quem
              olha não tem como saber que aquilo não veio de lugar nenhum.

              Agora a moeda aparece com "—". A linha não some — sumir faria a tela parecer
              que a moeda deixou de existir.
            */
            console.error('Cotação indisponível para ' + moeda.value + '-BRL:', err);
            return { moeda, valor: null };
          }),
      ),
    ).then((resultados) => {
      resultados.forEach(({ moeda, valor }) => {
        if (valor) sessionStorage.setItem(moeda.value, valor);
      });

      that.setState({
        data: resultados.map(({ moeda, valor }) => ({
          coin: moeda.label,
          value: valor ? valor.replace('.', ',') : '—',
          image: moeda.image,
        })),
      });
    });
  }

  getDate() {
    let date = new Date(new Date().toLocaleString("en-US", {timeZone: "America/Sao_Paulo"}));
    let day = dayOfWeek[date.getDay()];
    let month = date.toLocaleString('en-US', { month: 'long' });
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let period = 'AM';

    if(Number(hours) < 10)
      hours = '0' + hours;
    if(Number(hours) > 12){
      period = 'PM';
      hours = Number(hours) - 12;
      if(hours < 10)
        hours = '0' + hours;
    }
    if(Number(minutes) < 10)
      minutes = '0' + minutes;

    return `${this.state.translations[day]}, ${this.state.translations[month]} ${date.getDate()} - <b>${hours}:${minutes} ${this.state.translations[period]} - Brasília</b>`;
  }

  render() {
    return (
      <section className="CoinQuoteComponent" id="CoinQuoteComponent">
        <div className="desktop">
          <div className="">
            {
              // this.state.dataStock.map((item, index) => { return (
              //   <div key={index} className="itemQuote" style={{fontSize: "14px", marginRight: "10px"}}>
              //     <div className="textQuote">
              //       {item.label}<br/>
              //       <b>{(Number(item.open).toFixed(2) + '').replace('.', ',')} BRL | {(Number(item.close).toFixed(2) + '').replace('.', ',')} BRL</b>
              //     </div>
              //   </div>
              // )})
            }
            {
              // <div className="itemQuote" style={{borderRight: '1px solid #A6ABAF', height: '40px'}}></div>
            }
            {
              this.state.data.map((item, index) => { return (
                <div key={index} className="itemQuote" style={{fontSize: "14px"}}>
                  <img src={item.image} className="imgQuote" alt={this.state.translations.flag_icon}/>
                  <div className="textQuote">
                    {item.coin}<br/>
                    <b>{item.value} {this.state.translations.brl}</b>
                  </div>
                </div>
              )})
            }<br/>

            <div style={{fontSize: "14px"}} dangerouslySetInnerHTML={{__html: this.getDate()}} />
          </div>
        </div>
        <div className="mobile">
          <p onClick={()=>{this.setState({dispQuotes: !this.state.dispQuotes})}}><b>{this.state.translations.top_quotes}</b></p>
          <div className="dispQuotesMobile" style={(this.state.dispQuotes?{height: "90px"}:{height: "1px"})}>
            <div style={{width: "630px"}}>
              {
                this.state.data.map((item, index) => { return (
                  <div key={index} className="itemQuote" style={{fontSize: "14px"}}>
                    <img src={item.image} className="imgQuote" alt={this.state.translations.flag_icon}/>
                    <div className="textQuote">
                      {item.coin}<br/>
                      <b>{item.value} {this.state.translations.brl}</b>
                    </div>
                  </div>
                )})
              }
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CoinQuote;
